<template>
  <div class="shop-set-fulfilment-time wrapper">
    <div class="scroll">
      <p class="subtitle header has-text-black">
        <!-- <i>{{ $t("commerce.choose-fulfilment-method") }}</i> -->
        <i>Choose Date and Time</i>
      </p>
      <p class="notification">
        <i>Requires 6 hours prep time. Order by 2pm for same day fulfilment.</i>
      </p>

      <div v-if="!date" class="notification">
        <p class="subtitle">
          <i class="far fa-calendar-alt" />
          Select Date
        </p>
        <p
          v-for="i in 4"
          :key="i"
          class="button is-fullwidth"
          @click="date = i"
        >
          {{ prettyDate(i) }}
        </p>
      </div>

      <div v-if="date">
        <div class="notification" @click="date = null">
          Date: {{ prettyDate(date) }}
          <i class="is-pulled-right has-text-grey link">Change</i>
        </div>
        <div class="notification">
          <p class="subtitle">
            <i class="far fa-clock" />
            Select Time
          </p>
          <b-field>
            <!-- :min-time="minTime"
              :max-time="maxTime" -->
            <b-timepicker
              placeholder="Click to select..."
              :incrementMinutes="15"
              inline
            >
            </b-timepicker>
          </b-field>
          <a class="button is-fullwidth is-success" @click="submit">
            {{ $t("submit") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopSetFulfilmentTime",
  props: {
    // fulfilmentOptions: Array,
    // hasDelivery: Boolean,
  },
  data() {
    return {
      date: null,
      time: null,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    prettyDate(i) {
      var today = new Date();
      var dateI = today.setDate(today.getDate() + i);
      return new Date(dateI).toLocaleDateString();
    },
    submit() {
      // submit date time
      this.$emit("submit");
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  bottom: 0;
  height: calc(100vh - 184px);
  width: 100vw;
  overflow: hidden;
  /* background-color: #48cdf243; */
  background-color: white;
  /* z-index: 1102; */
  z-index: 3;
  backdrop-filter: blur(5px);
  text-align: left;
}
.scroll {
  height: 100%;
  overflow: scroll;
  padding-bottom: 20px;
}
.header {
  padding: 12px;
  padding-bottom: 4px;
  margin-bottom: 4px;
  font-size: 1.1em;
}
.notification {
  margin: 12px;
  padding: 12px;
  border: 1px solid #ddd;
}
.notification p {
  margin-bottom: 8px;
}
.fa,
.far {
  margin-right: 6px;
}
.hint {
  font-weight: 500;
  font-size: 0.8em;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 1);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(247, 211, 8, 0.6);
  }
}
.pulse {
  animation: shadow-pulse-gold 1s infinite;
}
.link {
  border-bottom: 1px #ccc dotted;
}
</style>